<div [innerHTML]="text"></div>
